<div [innerHTML]="text"></div>
